import { useLiteSiteStore } from "../store";

export function unstoreContact(id: string) {
  useLiteSiteStore.setState(({ contacts }) => {
    contacts.delete(id);

    return { contacts: new Map(contacts) };
  });
}
